import { ProductStockStatus } from '@pylot-data/enums/ProductStockStatus.d'
import { useTranslation } from 'next-i18next'
import type { BundleItemOption } from '@pylot-data/pylotschema'
import { QuantitySelector } from '../QuantitySelector/QuantitySelector'
import { sortAlphabetically } from '@components/alfakher/pylot-utils'
import { BundleTypeProps } from './type'
import formStyles from '@commonStyles/Forms.module.scss'
import { getDynamicPriceToAdd } from '@components/BundleProduct/Util/Prices'

export const Radio = ({
    selectedBundleProducts,
    setSelectedBundleProducts,
    bundleItem,
    setSelectedLabels,
    selectedLabels,
    dynamicPrice,
    currency,
    locale,
    mainFinalPrice,
    useFlavour = false
}: BundleTypeProps) => {
    const { options, uid, required } = bundleItem
    const active = selectedBundleProducts[uid as string]?.uid ?? ''
    const { t } = useTranslation('common')
    const filteredProduct = bundleItem.options?.filter((val) => {
        if (val?.label) {
            return val
        }
    })

    const sortedValues = filteredProduct?.sort((a, b) => {
        return sortAlphabetically(a?.label, b?.label)
    })

    const renderQty = (
        BundleItemOption: [BundleItemOption],
        active: string,
        uid: string
    ) => {
        const selectedOption = BundleItemOption.find((i) => active == i.uid)
        if (selectedOption) {
            if (selectedOption.can_change_quantity) {
                return (
                    <div className={formStyles.root}>
                        <QuantitySelector
                            quantity={
                                selectedBundleProducts[uid].value as number
                            }
                            setQuantity={(qty: number) => {
                                setSelectedBundleProducts(
                                    {
                                        ...selectedBundleProducts,
                                        [uid as string]: {
                                            uid: active,
                                            value: qty
                                        }
                                    },
                                    selectedOption?.product?.media_gallery
                                )
                            }}
                        />
                    </div>
                )
            }
        }
        return null
    }

    const isInstock = options?.find(
        (res) => res?.product?.stock_status === 'IN_STOCK'
    )
    return (
        <div className={formStyles.root}>
            <div className="">
                {!isInstock ? (
                    <div className="flex pb-1" key="checkbox-empty">
                        <input
                            type="radio"
                            className="form-radio"
                            name="radio-none"
                            checked={active === ''}
                            id="radio-none"
                        />
                        <label className="label" htmlFor="radio-none">
                            {t('All options are out of stock')}
                        </label>
                    </div>
                ) : (
                    ''
                )}
                {!required && (
                    <div className="flex pb-1" key="checkbox-empty">
                        <input
                            type="radio"
                            className="form-radio"
                            value=""
                            name="radio-none"
                            onChange={(e) => {
                                setSelectedBundleProducts({
                                    ...selectedBundleProducts,
                                    [uid as string]: {
                                        uid: '',
                                        value: 0
                                    }
                                })
                                setSelectedLabels({
                                    ...selectedLabels,
                                    [uid as string]: []
                                })
                            }}
                            checked={active === ''}
                            id="radio-none"
                        />
                        <label className="label" htmlFor="radio-none">
                            {t('None')}
                        </label>
                    </div>
                )}
                {sortedValues?.map((v, i: number) => {
                    const getOption = () => {
                        const flavourText = v?.product?.flavour_text

                        if (useFlavour && flavourText) {
                            return flavourText
                        }

                        return v?.label
                    }
                    const values: string = v?.product?.stock_status ?? ''
                    const OutOfstockValue: boolean = ProductStockStatus.OutOfStock.includes(
                        values
                    )
                    if (!OutOfstockValue) {
                        return (
                            <div key={`checkbox-${v?.uid}`}>
                                <div className="pb-1 flex">
                                    <input
                                        type="radio"
                                        className="form-radio"
                                        value={v?.uid}
                                        onChange={(e) => {
                                            e.persist()
                                            const productUid = e.target.value
                                            const selectedOption = options?.find(
                                                (i) => productUid == i?.uid
                                            )
                                            setSelectedBundleProducts(
                                                {
                                                    ...selectedBundleProducts,
                                                    [uid as string]: {
                                                        uid: productUid as string,
                                                        value:
                                                            selectedBundleProducts[
                                                                uid as string
                                                            ]?.value ||
                                                            (selectedOption?.quantity as number)
                                                    }
                                                },
                                                selectedOption?.product
                                                    ?.media_gallery
                                            )
                                            const getFlavour = () => {
                                                const flavour = selectedOption
                                                    ?.product?.flavour_text
                                                    ? [
                                                          selectedOption
                                                              ?.product
                                                              .flavour_text
                                                      ]
                                                    : []

                                                if (!flavour[0]) {
                                                    return getLabel()
                                                }

                                                return flavour
                                            }
                                            const getLabel = () => {
                                                return selectedOption?.label
                                                    ? [selectedOption?.label]
                                                    : []
                                            }
                                            setSelectedLabels({
                                                ...selectedLabels,
                                                [uid as string]: useFlavour
                                                    ? getFlavour()
                                                    : getLabel()
                                            })
                                        }}
                                        checked={v?.uid === active}
                                        id={v?.uid}
                                    />
                                    <label htmlFor={v?.uid} className="label">
                                        {getOption()}
                                        {getDynamicPriceToAdd(
                                            v as BundleItemOption,
                                            dynamicPrice,
                                            currency,
                                            locale,
                                            mainFinalPrice
                                        )}
                                    </label>
                                </div>
                            </div>
                        )
                    }
                })}
            </div>

            {renderQty(
                options as [BundleItemOption],
                active as string,
                uid as string
            )}
        </div>
    )
}

export default Radio
